import { parse } from 'query-string';
import pageActions from '../page/actions';
import fieldActions from '../fields/actions';
import groupActions from '../groups/actions';
import workflowActions from '../workflow/actions';
import sessionActions from '../session/actions';
import homeActions from '../home/actions';

function getParams() {
  const { market, product } = parse(window.location.search);
  return { market, product };
}

export default (state = {}, action) => {
  switch (action.type) {
    case pageActions.GO_SUCCESS:
    case groupActions.UPLOAD_SUCCESS:
    case fieldActions.RERENDER_SUCCESS:
      return {
        ...state,
        ...action.payload.data.meta.refs,
      };
    case homeActions.START_SUCCESS:
    case workflowActions.START_SUCCESS:
      return {
        ...state,
        ...action.payload.data.data,
      };
    case sessionActions.GET:
      return {
        ...state,
        ...getParams(),
        ...action.payload.data,
      };
    default:
      return state;
  }
};
